import { render, staticRenderFns } from "./onetwenty.vue?vue&type=template&id=9ba7b2d0&scoped=true&"
import script from "./onetwenty.vue?vue&type=script&lang=js&"
export * from "./onetwenty.vue?vue&type=script&lang=js&"
import style0 from "./onetwenty.vue?vue&type=style&index=0&id=9ba7b2d0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba7b2d0",
  null
  
)

export default component.exports